import React, { useState } from "react";
import { AuthView } from "../auth/AuthViewRouter";
import { useAuthForm } from "../../context/AuthFormContext";
import Button from "../ui/Button";
import FormGroup from "../ui/FormGroup";
import { validateEmail } from "../../utils/validation";
import forgotPasswordImg from "../../img/Forgot Password.svg";
import Input from "../ui/Input";
import FormError from "../ui/FormError";

interface LoginViewProps {
	onSwitchView: (view: AuthView) => void;
	identifier: string;
}

const LoginView: React.FC<LoginViewProps> = ({ onSwitchView, identifier }) => {
	const { state, login, reset } = useAuthForm();
	const [password, setPassword] = useState("");
	const [formError, setFormError] = useState<string | null>(null);

	const currentError = formError || (state.status === "error" ? state.error : null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setFormError(null);

		const emailValidation = validateEmail(identifier);
		if (!emailValidation.valid) {
			setFormError(emailValidation.error!);
			return;
		}

		if (!password.trim()) {
			setFormError("Введите пароль");
			return;
		}

		try {
			await login(identifier, password);
		} catch (error) {
			const message = error instanceof Error ? error.message : "Не удалось выполнить вход. Попробуйте ещё раз.";

			console.log("error message:", message);
			setFormError(message);
		}
	};

	const handleChangeMail = () => {
		setFormError(null);
		onSwitchView("identifier");
	};

	const showFloatingLabel = password.trim().length > 0 || !!currentError;

	return (
		<div className="auth-view">
			<p className="auth-verify-text">Для входа на сайт введите пароль</p>

			<form onSubmit={handleSubmit} noValidate>
				<div className="auth-verification-data">
					<div>
						<span className="auth-verification-num">{identifier}</span>
					</div>

					<button type="button" className="auth-change-num" onClick={handleChangeMail} disabled={state.status === "submitting"}>
						Изменить
					</button>
				</div>

				<FormGroup>
					<div className={`auth-field ${currentError ? "is-error" : ""}`}>
						{showFloatingLabel && (
							<label htmlFor="login-password" className="auth-field__label">
								Пароль
							</label>
						)}

						<Input
							id="login-password"
							value={password}
							onChange={(e) => {
								setPassword(e.target.value);
								setFormError(null);
								reset();
							}}
							placeholder="Пароль"
							disabled={state.status === "submitting"}
							error={!!currentError}
							passwordToggle={true}
							type="password"
						/>
					</div>
					<FormError message={currentError || undefined} />
				</FormGroup>

				<Button type="submit" variant="primary" loading={state.status === "submitting"} disabled={state.status === "submitting"} className="tw-w-full">
					{state.status === "submitting" ? "Проверка..." : "Войти"}
				</Button>

				<button type="button" className="auth-forgot-pass" onClick={() => onSwitchView("password-recovery-request")}>
					<img src={forgotPasswordImg} alt="Забыли пароль?" />
				</button>
			</form>
		</div>
	);
};

export default LoginView;
